import React from 'react';
import CTAButton from '@/components/CTAButton';
import { Check, X } from 'lucide-react';

const CourseIntroduction = () => {
  return (
    <div className="text-center">
      <div className="mb-6 sm:mb-8">
        <div className="inline-flex items-center gap-2 sm:gap-3 rounded-full bg-gradient-to-r from-[#FEE6D8] to-[#FEE6D8]/80 text-[#003a70] font-bold px-4 py-2 sm:px-6 sm:py-3 md:px-8 md:py-4 text-sm sm:text-base md:text-lg shadow-lg hover:shadow-xl transition-shadow">
          <span className="w-2 h-2 sm:w-3 sm:h-3 bg-[#003a70] rounded-full animate-pulse"></span>
          INTRODUCING
        </div>
      </div>
      
      {/* Course Logo */}
      <div className="mb-8 sm:mb-10 md:mb-12">
        <div className="w-full max-w-lg mx-auto">
          <div className="relative">
            <div className="absolute -inset-1 sm:-inset-2 bg-gradient-to-r from-[#003a70]/20 to-[#FEE6D8]/30 rounded-2xl sm:rounded-3xl blur-lg"></div>
            <div className="relative">
              <img 
                src="/lovable-uploads/26e79152-711e-4dec-8dc4-0c5a548c6f1d.png" 
                alt="Local AI Assistant Launchpad Course Logo" 
                className="w-full h-auto rounded-xl sm:rounded-2xl shadow-xl sm:shadow-2xl" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-8 sm:mb-10 md:mb-12">
          {/* What This Is NOT */}
          <div className="relative group h-full">
            <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-red-200 to-red-100 rounded-xl sm:rounded-2xl blur opacity-25 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white border-2 border-red-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full flex flex-col">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-red-100 rounded-lg sm:rounded-xl flex items-center justify-center">
                  <X className="text-red-600" size={16} />
                </div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-red-700">This is NOT</h3>
              </div>
              <div className="flex-grow flex flex-col justify-center text-left">
                <p className="text-red-700 text-sm sm:text-base md:text-lg leading-relaxed">
                  Another overwhelming, jargon-filled tech course that promises the world but leaves you more confused than when you started.
                </p>
                <p className="text-red-700 text-xs sm:text-sm md:text-base leading-relaxed mt-3 sm:mt-4 opacity-80">
                  No complex coding, no endless technical tutorials, no unrealistic promises.
                </p>
              </div>
            </div>
          </div>
          
          {/* What This IS */}
          <div className="relative group h-full">
            <div className="absolute -inset-0.5 sm:-inset-1 bg-gradient-to-r from-green-200 to-green-100 rounded-xl sm:rounded-2xl blur opacity-25 group-hover:opacity-40 transition-opacity"></div>
            <div className="relative bg-white border-2 border-green-200 rounded-xl sm:rounded-2xl p-4 sm:p-6 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full flex flex-col">
              <div className="flex items-center gap-3 sm:gap-4 mb-4 sm:mb-6">
                <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-green-100 rounded-lg sm:rounded-xl flex items-center justify-center">
                  <Check className="text-green-600" size={16} />
                </div>
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-green-700">This IS</h3>
              </div>
              <div className="flex-grow flex flex-col justify-center text-left">
                <p className="text-green-700 text-sm sm:text-base md:text-lg leading-relaxed">
                  A clear, actionable, step-by-step system created specifically for YOU – the insightful, results-driven local marketing agency owner.
                </p>
                <p className="text-green-700 text-xs sm:text-sm md:text-base leading-relaxed mt-3 sm:mt-4 opacity-80">
                  Simple tools, proven strategies, immediate results you can implement today.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-8 sm:mt-10 md:mt-12">
        <CTAButton 
          variant="primary" 
          className="text-base sm:text-lg md:text-xl px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-6 w-full sm:w-auto bg-gradient-to-r from-[#003a70] to-[#003a70]/90 hover:from-[#003a70]/90 hover:to-[#003a70] shadow-xl sm:shadow-2xl transform hover:scale-105 transition-all duration-300" 
          to="https://cart.deliciousmarketing.io/local-ai-assistant-launchpad/?coupon=AI-LAUNCHPAD"
        >
          Get Instant Access Now
        </CTAButton>
        
        <p className="mt-4 sm:mt-6 text-gray-600 text-lg sm:text-xl md:text-2xl font-semibold">
          Join hundreds of agency owners already transforming their business
        </p>
      </div>
    </div>
  );
};

export default CourseIntroduction;
